const EDITOR_VERSION = "13.0.0";

export default EDITOR_VERSION;
